import { useEffect } from "react";
import axios from "axios";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { Manifesto } from "@/components/site/Manifesto";
import { FeedIngredients } from "@/components/site/FeedIngredients";
import { Spices } from "@/components/site/Spices";
import { Tea } from "@/components/site/Tea";
import { Founders } from "@/components/site/Founders";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
  }, []);

  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <BrandMarquee />
      <Manifesto />
      <FeedIngredients />
      <Spices />
      <Tea />
      <Founders />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
